import React, { useState, useEffect } from 'react';
import moment from 'moment';
import axios from 'axios';
import "./ReportDetails.css";
import Playlandmarks from "../playlandmarks/Playlandmarks";

const ReportDetails = ({ data, patientDate }) => {
    const [selectedPatientId, setSelectedPatientId] = useState(null);
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [rawLogs, setRawLogs] = useState([]);
    const [rawLogsDate, setRawLogsDate] = useState(patientDate);
    const [rawLogsLoading, setRawLogsLoading] = useState(false);
    const [rawActivityId, setRawActivityId] = useState(null);
    const [debugImages, setDebugImages] = useState([]);
    const [showDebugImages, setShowDebugImages] = useState(false);

    useEffect(() => {
        if (rawActivityId && patientDate) {
            setRawLogsLoading(true);
            axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
            const patientDateStr = moment(rawLogsDate).format("YYYY-MM-DD");
            axios.post(window.ajaxLink + "cloud_programs/getActivityRawData", { activityId: rawActivityId, patientDateStr: patientDateStr })
                .then((res) => {
                    if (res.data.responseData) {
                        setRawLogs(res.data.responseData);
                        setRawLogsLoading(false);
                    }
                }).catch((err) => {
                    console.error(err);
                    setRawLogsLoading(false);
                });
        }
    }, [rawActivityId, patientDate, rawLogsDate]);

    useEffect(() => {
        if (selectedTaskId && showDebugImages) {
            setRawLogsLoading(true);
            axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
            axios.post(window.ajaxLink + "cloud_programs/getDebugImages", { taskId: selectedTaskId})
                .then((res) => {
                    if (res.data.responseData) {
                        setDebugImages(res.data.responseData);
                        setRawLogsLoading(false);
                    }
                }).catch((err) => {
                    console.error(err);
                    setRawLogsLoading(false);
                });
        }
    },[showDebugImages, selectedTaskId] )

    const isRedClass = (value) => value === "No" || value === "N/A" || value === "";
    const isLightOrangeClass = (value) => value === "Partially Complete";
    const isRedType = (value) => value.toLowerCase().indexOf('error') > -1 || value.toLowerCase().indexOf('instability') > -1;

    const groupedData = data.reduce((acc, current) => {
        const { patientId, taskId, taskName, hasVideo, patientName, hasPreAuthorizationPopup, date, time, painBefore, cameraAccess, exercises, notStartedExercises, afterPain, activity_id, feedback } = current;

        if (!acc[patientId]) {
            acc[patientId] = {
                patientId,
                patientName,
                tasks: []
            };
        }

        acc[patientId].tasks.push({
            taskId,
            taskName,
            activity_id,
            hasVideo,
            hasPreAuthorizationPopup,
            date,
            time,
            painBefore,
            cameraAccess,
            exercises,
            notStartedExercises,
            afterPain,
            feedback
        });

        return acc;
    }, {});
    const result = Object.values(groupedData);

    const handleShowTasks = (patientId) => {
        if (selectedPatientId === patientId) {
            setSelectedPatientId(null);
            setSelectedTaskId(null);
        } else {
            setSelectedPatientId(patientId);
            setSelectedTaskId(null);
        }
    };

    const handleShowExercises = (taskId) => {
        if (selectedTaskId === taskId) {
            setSelectedTaskId(null);
        } else {
            setSelectedTaskId(taskId);
        }
    };

    const [videoOpen, setVideoOpen] = useState(false);
    const openPlayVideo = (i) => {
        if (!videoOpen) {
            axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
            axios
                .post(window.ajaxLink + "cloud_dashboard/load-mp-landmarks", { exercise_id: i })

                .then((res) => {
                    if (res.data.responseData) {
                        var resp = res.data.responseData;
                        if (resp.s3_link) {
                            getMPDataFromS3(resp.s3_link);
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }

        setVideoOpen(!videoOpen);
    };

    const getMPDataFromS3 = (link) => {
        window.mpLoad = link;
    };

    const handleRawLogsActivity = (activityId, date) => {
        if (rawActivityId === activityId) {
            setRawActivityId(null);
            setRawLogsDate(patientDate);
        } else {
            setRawActivityId(activityId);
            setRawLogsDate(date);
        }
    };

    const handleShowDebugImages = () => {
        setShowDebugImages(prevState => !prevState);
    };


    return (
        <>
            <div className="dash_task_table dash_task_tablelogs" style={{border: "none"}}>
                {result && Object.keys(result).length > 0 ? (
                    <>
                        {Object.entries(result).map(([index, patient]) => (
                            <div key={index} className='dash_task_table'  style={{ marginBottom: '10px' }}>
                                <div className="dash_task_single_row" style={{ textAlign: "center", border: '0px none', marginBottom: '6px' }} onClick={() => handleShowTasks(patient.patientId)}>
                                    <div className="dash_task_reg dash_task_single_desc">
                                        {patient.patientId}
                                    </div>
                                    <div className="dash_task_reg dash_task_single_desc">
                                        {patient.patientName}
                                    </div>
                                    <div className="dash_task_reg dash_task_single_desc"></div>
                                    <div className="dash_task_reg dash_task_single_desc"></div>
                                    <div className="dash_task_reg dash_task_single_desc"></div>
                                    <div className='dash_task_reg dash_task_single_desc'></div>
                                    <div className='dash_task_reg dash_task_single_desc'></div>
                                </div>
								
								{selectedPatientId === patient.patientId ?
									<div className="dash_task_single_row dash_task_sr_no_bord patient_rep_titles" style={{ textAlign: "center", marginBottom: '0px' }}>
										<div className="dash_task_reg dash_task_single_desc">
											Task Name
										</div>
										<div className="dash_task_reg dash_task_single_desc">
											Camera Access
										</div>
										<div className="dash_task_reg dash_task_single_desc">Before Pain</div>
										<div className="dash_task_reg dash_task_single_desc">Date & Time</div>
										<div className='dash_task_reg dash_task_single_desc'>After Pain</div>
										<div className='dash_task_reg dash_task_single_desc'>Feedback</div>
										<div className="dash_task_reg dash_task_single_desc">No. Exercises</div>
								</div> : <></>}
						
                                {selectedPatientId === patient.patientId && patient.tasks?.map((task, tsk) => (
                                    <React.Fragment key={tsk}>
                                        <div className="dash_task_single_row" style={{ textAlign: "center" }} onClick={() => handleShowExercises(task.taskId)}>
                                            <div className={`dash_task_reg dash_task_single_desc ${isRedClass(task.taskName) ? 'red' : ''}`}>
                                                <p>{task.taskName}</p>
                                            </div>
                                            <div className={`dash_task_reg dash_task_single_desc ${isRedClass(task.cameraAccess) ? 'red' : ''}`}>
                                                <p>{task.cameraAccess === "Yes" ? "Yes" : "No"}</p>
                                            </div>
                                            <div className={`dash_task_reg dash_task_single_desc ${isRedClass(task.painBefore) ? 'red' : ''}`}>
                                                <p>{task.painBefore ? task.painBefore : "N/A"}</p>
                                            </div>
                                            <div className={`dash_task_reg dash_task_single_desc ${isRedClass(task.date) ? 'red' : ''}`}>
                                                <p>{moment(task.date).format("L")}</p> {task.time}
                                            </div>
                                            <div className={`dash_task_reg dash_task_single_desc ${isRedClass(task.afterPain) ? 'red' : ''}`}>
                                                <p>{task.afterPain ? task.afterPain : "N/A"}</p>
                                            </div>
                                            <div className={`dash_task_reg dash_task_single_desc ${isRedClass(task.feedback) ? 'red' : ''}`}>
                                                <p>{task.feedback}</p>
                                            </div>
                                            <div className={`dash_task_reg dash_task_single_desc ${isRedClass(task.exercises.length) ? 'red' : ''}`}>
                                                <p>{task.exercises.length}</p>
                                            </div>
                                        </div>
                                        {selectedTaskId === task.taskId && (
                                            <div className="dash_exr_info">
                                                <div className="dash_task_single_row dt_sr_no_bord_bold dt_bord_addit patient_rep_titles">
                                                    <div className=" dt_rep">
                                                        <div className="dt_shrink">#</div>
                                                    </div>
                                                    <div className="dash_task_reg dt_sd_top_desc ">
                                                        Exercise Name
                                                    </div>
                                                    <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                                        Reps
                                                        <div className="dt_sd_addit_desc task_exrc_centered">Done/Target</div>
                                                        <div className="dt_sd_addit_desc task_exrc_centered">Max</div>
                                                    </div>
                                                    <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                                        On Screen
                                                        <div className="dt_sd_addit_desc task_exrc_centered">
                                                            Yes / No
                                                        </div>
                                                        <div className="dt_sd_addit_desc task_exrc_centered">In seconds</div>
                                                    </div>
                                                    <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                                        Start Position
                                                        <div className="dt_sd_addit_desc task_exrc_centered">Yes / No</div>
                                                        <div className="dt_sd_addit_desc task_exrc_centered">In seconds</div>
                                                    </div>
                                                    <div className="dash_task_reg dt_sd_top_desc task_exrc_centered">
                                                        Status
                                                        <div className="dt_sd_addit_desc task_exrc_centered">
                                                            Completed / Not Completed
                                                        </div>
                                                    </div>
                                                    <div className="dt_rep">
                                                        <div className="dt_shrink"></div>
                                                    </div>
                                                </div>
                                                {task.exercises.map((exercise, exr) => (
                                                    <div key={exr}>
                                                        <hr />
                                                        <div className="dash_task_single_row info_icon dt_sr_no_bord_bold dt_bord_addit" style={{ backgroundColor: "white" }}>
                                                            <div className="dt_rep">
                                                                <div className="dt_shrink dt_shrink_in_col">
                                                                    {exr + 1}
                                                                    {exercise.hasVideo > 0 && (
                                                                        <div
                                                                            className="smallPlay"
                                                                            onClick={() => openPlayVideo(exercise.activity_id)}
                                                                        ></div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(exercise.name) ? 'red' : ''}`}>
                                                                {exercise.name}
                                                            </div>
                                                            <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(exercise.reps) ? 'red' : ''}`}>
                                                                {exercise.reps ? exercise.reps : "N/A"}
                                                                <div className={`dt_sd_addit_desc task_exrc_centered ${isRedClass(exercise.rom_max) ? 'red' : ''}`}>
                                                                    {exercise.rom_max ? exercise.rom_max : "N/A"}
                                                                </div>
                                                            </div>
                                                            <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(exercise.onScreen) ? 'red' : ''}`}>
                                                                {exercise.onScreen === "Yes" ? "Yes" : "No"}
                                                                <div className={`dt_sd_addit_desc task_exrc_centered ${isRedClass(exercise.onScreenTime) ? 'red' : ''}`}>
                                                                    {exercise.onScreenTime ? exercise.onScreenTime : "N/A"}
                                                                </div>
                                                            </div>
                                                            <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(exercise.startPosition) ? 'red' : ''}`}>
                                                                {exercise.startPosition === "Yes" ? "Yes" : "No"}
                                                                <div className={`dt_sd_addit_desc task_exrc_centered ${isRedClass(exercise.startPositionTime) ? 'red' : ''}`}>
                                                                    {exercise.startPositionTime ? exercise.startPositionTime : "N/A"}
                                                                </div>
                                                            </div>
                                                            <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(exercise.completed) ? 'red' : ''} ${isLightOrangeClass(exercise.completed) ? 'lightOrangeBg' : ''}`}>
                                                                {exercise.completed === "Yes" ? "Completed" : exercise.completed === 'Partially Complete' ? "Partially Complete" : "Not Completed"}
                                                            </div>
                                                            <div className="dt_rep" style={{height: '14px'}} onClick={() => handleRawLogsActivity(exercise.activity_id, task.date)}>
                                                                <div className="dt_shrink"></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                                
                                                {task.notStartedExercises ? (
                                                    <>
                                                        <h3 className='dash_task_reg rpt_not_head'>Not Started Yet</h3>
                                                        {task.notStartedExercises.map((notStartedExercise, ins) => (
                                                            <div key={ins + Math.random()}>
                                                                <hr />
                                                                <div className="dash_task_single_row info_icon dt_sr_no_bord_bold dt_bord_addit" style={{ backgroundColor: "white" }}>
                                                                    <div className="dt_rep">
                                                                        <div className="dt_shrink dt_shrink_in_col">
                                                                            {ins + 1}
                                                                            {notStartedExercise.hasVideo > 0 && (
                                                                                <div
                                                                                    className="smallPlay"
                                                                                    onClick={() => openPlayVideo(notStartedExercise.activity_id)}
                                                                                ></div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(notStartedExercise.name) ? 'red' : ''}`}>
                                                                        {notStartedExercise.name}
                                                                    </div>
                                                                    <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(notStartedExercise.reps) ? 'red' : ''}`}>
                                                                        {notStartedExercise.reps ? notStartedExercise.reps : "N/A"}
                                                                        <div className={`dt_sd_addit_desc task_exrc_centered ${isRedClass(notStartedExercise.rom_max) ? 'red' : ''}`}>
                                                                            {notStartedExercise.rom_max ? notStartedExercise.rom_max : "N/A"}
                                                                        </div>
                                                                    </div>
                                                                    <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(notStartedExercise.onScreen) ? 'red' : ''}`}>
                                                                        {notStartedExercise.onScreen === "Yes" ? "Yes" : "No"}
                                                                        <div className={`dt_sd_addit_desc task_exrc_centered ${isRedClass(notStartedExercise.onScreenTime) ? 'red' : ''}`}>
                                                                            {notStartedExercise.onScreenTime ? notStartedExercise.onScreenTime : "N/A"}
                                                                        </div>
                                                                    </div>
                                                                    <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(notStartedExercise.startPosition) ? 'red' : ''}`}>
                                                                        {notStartedExercise.startPosition === "Yes" ? "Yes" : "No"}
                                                                        <div className={`dt_sd_addit_desc task_exrc_centered ${isRedClass(notStartedExercise.startPositionTime) ? 'red' : ''}`}>
                                                                            {notStartedExercise.startPositionTime ? notStartedExercise.startPositionTime : "N/A"}
                                                                        </div>
                                                                    </div>
                                                                    <div className={`dash_task_reg dt_sd_top_desc task_exrc_centered ${isRedClass(notStartedExercise.completed) ? 'red' : ''}`}>
                                                                        {notStartedExercise.completed === "Yes" ? "Completed" : "Not Completed"}
                                                                    </div>
                                                                    <div className="dt_rep" style={{ height: '14px' }} onClick={() => handleRawLogsActivity(notStartedExercise.activity_id, task.date)}>
                                                                        <div className="dt_shrink"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </>
                                                ) : (
                                                    " "
                                                )}

                                                {task.hasPreAuthorizationPopup === 1 ? (
                                                    <div className='dash_task_table debug_images' >
                                                        <p style={{ fontSize: "18px", fontWeight: "bolder" }}>Debug Images :</p>
                                                        <div onClick={() => handleShowDebugImages()} className='show_debug_images_icon'></div>
                                                    </div>
                                                ) : (
                                                    " "
                                                )}

                                            </div>
                                        )}
                                    </React.Fragment>
                                ))}
                            </div>
                        ))}
                    </>
                ) : (
                    <div className="dash_task_data_empty">No data available.</div>
                )}
            </div>

            {rawActivityId && (
                <>
                    <div className="patient_report_raw dlt_wrapper">
                        <div className="approval_close tsk_info_cls" style={{ zIndex: '1000000' }} onClick={() => handleRawLogsActivity(null)}></div>
                        <div className="dash_task_info_pop dash_task_info_pop_width">
                            <div className="dash_task_info_title">Raw Logs</div>
                            {rawLogsLoading ? (
                                <div className="p_load"></div>
                            ) : (
                                <>
                                    <div className='dash_task_table'>
                                        <div className="dash_task_single_row dash_task_sr_no_bord">
                                            <div className="dash_task_reg dash_task_single_desc">Event Type</div>
                                            <div className='dash_task_reg dash_task_single_desc'>Event Text</div>
                                            <div className="dash_task_reg dash_task_single_desc">Event Date & Time</div>
                                        </div>
                                            {rawLogs && rawLogs.length > 0 ? (
                                                <>
                                                    {rawLogs.map((log, index) => (
                                                        <>
                                                            <div key={index} className='dash_task_table' style={{ marginBottom: '10px', backgroundColor: (isRedType(log.event_type) ? 'rgb(249, 182, 182)' : 'none') }}>
                                                                <div className="dash_task_sr_no_bord" style={{ textAlign: "left", marginBottom: "0px", wordWrap: 'break-word' }}>
                                                                    <div>{log.event_text}</div>
                                                                </div>
                                                                <div className="dash_task_sr_no_bord">
                                                                    <div className="dash_task_reg dash_task_single_desc">{log.event_type}</div>
                                                                    <div className="dash_task_reg dash_task_single_desc" style={{ textAlign: "right" }}>{moment(log.event_time).format("MM/DD/YYYY HH:mm:ss")}</div>
                                                                </div>
                                                            </div>
                                                        </>
                                                    ))}
                                                </>
                                            ) : (
                                                <div className="dash_task_data_empty">No data available.</div>
                                            )}
                                    </div>
                                </>
                            )
                            }
                        </div>
                    </div>
                </>
            )}

            {showDebugImages &&  (
                <>
                    <div className="patient_report_raw dlt_wrapper">
                        <div className="approval_close tsk_info_cls" style={{ zIndex: '1000000' }} onClick={() => handleShowDebugImages()}></div>
                        <div className="dash_task_info_pop dash_task_info_pop_width">
                            <div className="dash_task_info_title">Debug Images</div>
                            {rawLogsLoading ? (
                                <div className="p_load"></div>
                            ) : (
                                <>
                                        <div className="dash_task_single_row dt_sr_no_bord_bold dt_bord_addit patient_rep_titles debug_images_popup">
                                            {debugImages.map((debugImage, index) => (
                                                <>
                                                    <div key={index} className='dash_task_table' style={{ marginBottom: '10px', display:"block" }}>
                                                        <div className="dash_task_sr_no_bord" style={{ textAlign: "center", marginBottom: "0px" }}>
                                                            <img style={{borderRadius:"10px"}} src={debugImage.image.substr(0, 5) === 'data:' ? debugImage.image : 'data:image/png;base64,'+debugImage.image} alt={`Debug ${index}`} />
                                                        </div>
                                                    </div>
                                                </>
                                            ))}
                                        </div>
                                </>
                            )}
                        </div>
                    </div>
                </>
            )}

            <div style={{ display: videoOpen ? "block" : "none" }}>
                <Playlandmarks videoLandmarks={videoOpen} doClose={() => openPlayVideo(false)} />
            </div>
        </>
    );
};

export default ReportDetails;
